export const BIG_CITIES_RADIUS = 25000;
export const OBLAST_CENTERS_RADIUS = 12000;
export const REGION_RADIUS = 15000;
export const CITY_REGION_RADIUS = 10000;
export const DEFAULT_RADIUS = 8000;

export const BIG_CITIES = ['Київ', 'Харків', 'Одеса', 'Дніпро', 'Донецьк'];

export const OBLAST_CENTERS_CITIES = [
  'Львів',
  'Запоріжжя',
  'Вінниця',
  'Полтава',
  'Чернігів',
  'Суми',
  'Хмельницький',
  'Черкаси',
  'Житомир',
  'Чернівці',
  'Рівне',
  'Кропивницький',
  'Івано-Франківськ',
  'Тернопіль',
  'Луцьк',
  'Ужгород',
  'Луганськ',
  'Миколаїв',
  'Херсон',
];
